<template>
  <div class="desp">
    <div class="desp-header">
      <div class="label">{{ companyDetailsTitle }}</div>
      <div class="opts">
        <el-button
          v-if="
            (detail.applymentStatus === 'REVISING' ||
              detail.applymentStatus === 'CORRECTED' ||
              detail.applymentStatus === 'ILLEGAL' ||
              detail.applymentStatus === 'AUDIT_FAIL' ||
              detail.applymentStatus === 'REFUND_APPLY_DENY' ||
              detail.applymentStatus === 'REFUND_APPLY_REJECT' ||
              detail.applymentStatus === 'ACRA_REJECTED') &&
            isApplymentAuth('company:coordinate')
          "
          @click="openEdit()"
          ref=""
        >
          Edit
        </el-button>
      </div>
    </div>
    <!-- Malaysia 新增字段： Registered Address / Service Address -->
    <template v-if="isMalaysia">
      <!-- Registered Address -->
      <div class="desp-items-group">
        <div class="desp-items-group-title">Registered Address</div>
        <div class="desp-item">
          <div class="desp-item-self no-event">
            <el-radio-group :value="detail.registeredOfficeType">
              <div v-if="nativeRegisteredAddress.length">
                <el-radio class="pt10 pb10" :label="1">
                  <span>Consent to use Estar Business Advisory Sdn. Bhd. ("EStar")'s registration address</span>
                  <div class="mt6 ml24" v-if="detail.registeredOfficeType === 1">
                    <el-radio-group :value="detail.registeredOfficeId">
                      <el-radio v-for="office in nativeRegisteredAddress" :key="office.id" :label="office.id">
                        <span class="native-addr-text">{{ formatNativeAddress(office) }}</span>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </el-radio>
              </div>
              <div>
                <el-radio class="pt6" :label="2">
                  <span>Use other registration address</span>
                  <div class="mt6 ml24" v-if="detail.registeredOfficeType === 2">
                    <div class="native-addr-text">
                      {{ formatCustomRegisteredAddress(detail) }}
                    </div>
                  </div>
                </el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <!-- Service Address -->
      <div class="desp-items-group">
        <div class="desp-items-group-title">Service Address</div>
        <div class="desp-item">
          <div class="desp-item-self no-event">
            <el-radio-group :value="detail.serviceAddressType">
              <div>
                <el-radio class="pt10 pb10" :label="1">Same As Registered Address</el-radio>
              </div>
              <div>
                <el-radio class="pt6" :label="2">
                  <span>Use other service address</span>
                  <div class="mt6 ml24" v-if="detail.serviceAddressType === 2">
                    <div class="native-addr-text">
                      {{ formatCustomServiceAddress(detail) }}
                    </div>
                  </div>
                </el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
    </template>
    <template v-if="detail.businessType == 'COMPANY_INCORPORATION'">
      <div class="desp-items-group">
        <div class="desp-items-group-title">Financial Year End (e.g. 31 December)</div>
        <div class="desp-item">
          <!-- <div class="desp-item-self">{{ detail.financialYearEnd }}</div> -->
          <div class="desp-item-self" v-if="detail.financialYearEnd && detail.financialYearEnd.includes('/')">
            <span class="mr20">Month {{ detail.financialYearEnd.split("/")[0] }}</span>
            <span>Date {{ detail.financialYearEnd.split("/")[1] }}</span>
          </div>
        </div>
      </div>
      <div class="desp-items-group">
        <div class="desp-items-group-title">Financial Year Period</div>
        <div class="desp-item">
          <div class="desp-item-self">{{ detail.financialYearPeriod }}</div>
        </div>
      </div>
    </template>

    <!-- 弹窗 -->
    <edit-modal
      v-if="editVisible"
      ref="editModal"
      :businessType="detail.businessType"
      :country="country"
      :nativeRegisteredAddress="nativeRegisteredAddress"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EditModal from "./modal/Edit.vue";
export default {
  components: {
    EditModal,
  },
  props: {
    detail: {
      type: Object,
      default: function () {
        return {
          financialYearEnd: "empty",
          financialYearPeriod: "empty",
          businessType: "",
        };
      },
    },
    country: {
      type: String,
      default: "",
    },
    nativeRegisteredAddress: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dataListLoading: false,
      editVisible: false,
    };
  },
  computed: {
    ...mapGetters("constant", ["getApplyStepInfo"]),
    isMalaysia() {
      return this.country === "Malaysia";
    },
    companyDetailsTitle() {
      const info = this.getApplyStepInfo("companyDetails", this.country, this.detail.businessType);
      return info.title || "Company Details";
    },
  },
  methods: {
    formatNativeAddress(office) {
      const addressParts = office.addressLine1
        ? [office.addressLine1, office.addressLine2, office.addressLine3].filter(Boolean)
        : [office.address].filter(Boolean);
      const line1 = addressParts.join(", ");
      const line2 = [office.country, office.state, office.city, office.postalCode].filter(Boolean).join(", ");
      return line1 + "\n" + line2;
    },
    formatCustomRegisteredAddress(detail) {
      const line1 = [detail.registeredOfficeAddressLine1, detail.registeredOfficeAddressLine2, detail.registeredOfficeAddressLine3]
        .filter(Boolean)
        .join(", ");
      const line2 = [detail.registeredOfficeCountry, detail.registeredOfficeState, detail.registeredOfficeCity, detail.registeredOfficePostalCode]
        .filter(Boolean)
        .join(", ");
      return line1 + "\n" + line2;
    },
    formatCustomServiceAddress(detail) {
      const line1 = [detail.serviceAddressLine1, detail.serviceAddressLine2, detail.serviceAddressLine3].filter(Boolean).join(", ");
      const line2 = [detail.serviceAddressCountry, detail.serviceAddressState, detail.serviceAddressCity, detail.serviceAddressPostalCode]
        .filter(Boolean)
        .join(", ");
      return line1 + "\n" + line2;
    },
    async openEdit() {
      this.editVisible = true;
      await this.$nextTick();
      this.$refs.editModal.init(this.detail);
    },
  },
};
</script>
<style lang="scss" scoped>
.native-addr-text {
  font-size: 12px;
  line-height: 16px;
  white-space: pre-line;
  display: inline-block;
  vertical-align: middle;
}
</style>
